import { IActionHelper } from '../../models/action.model';
import IHelper from '../../models/helper.models';
import { FETCH, REMOVE, SAVE, UPDATE } from './actionTypes';

const defaultStore: IHelper = {
  localCountry: {
    code: '',
    alpha3Code: '',
    dialCode: '',
    aditionalData: '{}',
    language: '',
    specificLanguage: '',
    name: '',
    termsFileUrl: null,
    flag: '',
  },
  countries: [],
};

export default function helperReducer(
  state: IHelper = defaultStore,
  action: IActionHelper
) {
  switch (action.type) {
    case SAVE:
      return {
        localCountry: action.payload.localCountry,
        countries: action.payload.countries,
      };

    case FETCH:
      return {
        ...state,
      };

    case UPDATE:
      return {
        ...state,
        ...action.payload,
      };

    case REMOVE:
      return {
        ...state,
        localCountry: {
          code: '',
          alpha3Code: '',
          dialCode: '',
          aditionalData: '{}',
          language: '',
          specificLanguage: '',
          name: '',
          termsFileUrl: null,
          flag: '',
        },
        countries: [],
      };

    default:
      return state;
  }
}
